import React from 'react';
import { Form, Radio } from 'semantic-ui-react';

export default function NewMessagePane(
    props: { type: 'Object', onCancel: () => void, onConfirm: () => void, open: boolean } = {
        open: false
    }
) {
    return (
        <Form id="newmessage" onSubmit={e => this.onSubmit(e)}>
            <Form.Field>
                <label>Export Type:</label>
                {props.exportTypes.map(item => (
                    <Radio
                        key={item.value}
                        label={item.text}
                        name={item.value}
                        value={attached.value}
                        checked={attached.value === item.value}
                        onChange={() => this.setState({ attached: item })}
                        style={{ paddingLeft: '1rem' }}
                    />
                ))}
            </Form.Field>
            <Form.Dropdown
                autoFocus
                fluid
                multiple
                name="selectedDeliveryMethods"
                label="Delivery Method"
                onChange={(e, data) => this.setState({ selectedDeliveryMethods: data.value })}
                options={deliveryTypes}
                search
                selection
                value={selectedDeliveryMethods}
            />
            <Recipients
                onChange={this.onChangeRecipient}
                phone={phone}
                selectedDeliveryMethods={selectedDeliveryMethods}
                userId={userId}
                users={users}
            />
            <Divider style={{ margin: '2rem 0' }} />
            <Form.Input
                fluid
                name="subject"
                label="Subject"
                onChange={(e, data) => this.setState({ subject: data.value })}
                value={this.state.subject}
            />
            <Form.TextArea
                name="message"
                label="Message"
                onChange={(e, data) => this.setState({ message: data.value })}
                value={this.state.message}
            />
        </Form>
    );
}

function Recipients(props: Object) {
    const userDisabled = !props.selectedDeliveryMethods.find(
        el => el === 1 || el === 2 || el === 4
    );
    const phoneDisabled = !props.selectedDeliveryMethods.find(el => el === 3);
    return (
        <Form.Group widths="equal">
            {/* <Form.Dropdown
                defaultValue={props.userId ? undefined : props.users[0].value}
                disabled={userDisabled}
                name="userId"
                label="User"
                onChange={(e, data) => props.onChange('userId', data.value)}
                options={props.users}
                value={props.userId}
                width={14}
            /> */}
            <Form.Input
                disabled={phoneDisabled}
                label="Phone"
                name="phone"
                onChange={(e, data) => props.onChange('phone', data.value)}
                value={props.phone}
            />
        </Form.Group>
    );
}



// WEBPACK FOOTER //
// ./components/molecules/NewMessagePane.jsx